import { createRootRouteWithContext } from '@tanstack/react-router';
import RootLayout from '../components/RootLayout/RootLayout';

export const Route = createRootRouteWithContext()({
  component: RootLayout
});
